import { useMemo } from "react";
import ReactCountryFlag from "react-country-flag";
// @mui
import { Box, Grid, LinearProgress, Typography } from "@mui/material";
// utils
import { sortCountryAds } from "../../utils";
import { CompetitorAds } from "../../CompetitorAnalytics";

// -----------------------------------------------------------------------------------

export default function CountryAdsDetails({ data }: { data?: CompetitorAds }) {
  const countryList = useMemo(
    () => data && sortCountryAds(data.top_countries),
    [data],
  );

  return (
    <>
      <Typography
        sx={{
          fontSize: 30,
          fontWeight: 600,
          lineHeight: "38px",
          color: "grey.900",
          mb: 1,
        }}
      >
        {`${data?.total_ads?.toLocaleString()} Ads`}
      </Typography>
      <Grid container sx={{ flexDirection: "column" }}>
        {countryList?.map((each) => {
          if (!each.ad_country) {
            return null;
          }
          return (
            <Grid  sx={{ height: 42, mb: 2 }} key={each.ad_country}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  mt: 2,
                }}
              >
                {each.ad_country !== "Others" && (
                  <ReactCountryFlag
                    countryCode={each.ad_country}
                    svg
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                )}
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: "20px",
                    fontWeight: 500,
                    ml: 2,
                  }}
                >
                  {each.ad_country}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-end",
                  ml: "auto",
                }}
              >
                <LinearProgress
                  sx={{
                    height: 10,
                    width: { xs: "100%", md: 215 },
                    borderRadius: 0,
                    "& .MuiLinearProgress-bar": { borderRadius: 0 },
                  }}
                  variant="determinate"
                  value={
                    data?.total_ads
                      ? (each.ad_count / data?.total_ads) * 100
                      : 0
                  }
                />
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: "20px",
                    fontWeight: 500,
                    ml: 2,
                    position: "relative",
                    top: "5px",
                  }}
                >
                  {each.ad_count}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
